import { GALLERY } from "./data";
import { Chapter, Rise } from "./motion";

const ROTS = ["-rotate-1", "rotate-1", "-rotate-2", "rotate-2", "rotate-0"];

const Gallery = () => (
  <section
    id="gallery"
    data-testid="gallery-section"
    className="border-b-2 border-ink bg-cream"
  >
    <div className="mx-auto max-w-[1500px] px-4 py-20 sm:px-6 lg:py-28">
      <Rise>
        <Chapter num="05" label="The proof" />
      </Rise>
      <Rise delay={0.1}>
        <h2 className="mt-6 font-display text-[14vw] uppercase leading-[0.85] sm:text-8xl lg:text-[10rem]">
          Fresh out
          <br />
          the <span className="text-rust">chair</span>
        </h2>
      </Rise>

      <div className="mt-14 columns-2 gap-5 md:columns-3 [&>*]:mb-5">
        {GALLERY.map((g, i) => (
          <Rise key={g.src + i} delay={0.04 * (i % 3)}>
            <figure
              data-testid={`gallery-item-${i}`}
              className={`group relative break-inside-avoid border-2 border-ink bg-paper p-2 shadow-hard-sm transition-transform duration-200 hover:-translate-y-1 hover:rotate-0 ${ROTS[i % ROTS.length]}`}
            >
              <div className={`overflow-hidden ${g.ratio}`}>
                <img
                  src={g.src}
                  alt={g.alt}
                  loading="lazy"
                  className="h-full w-full object-cover grayscale contrast-[1.15] transition-[filter] duration-300 group-hover:grayscale-0"
                />
              </div>
              <figcaption className="absolute -top-3 right-3 rotate-6 border border-ink bg-paper px-2 py-0.5 font-hand text-base text-rust shadow-hard-sm">
                {g.tag}
              </figcaption>
            </figure>
          </Rise>
        ))}
      </div>

      <Rise delay={0.15}>
        <p className="mt-10 font-hand text-2xl text-ink/70">
          Shot right here — Fitzroy St &amp; Jackson St, St Kilda.
        </p>
      </Rise>
    </div>
  </section>
);

export default Gallery;
